module.exports = framework_b1b97deb295ad9d04ea1;